import { UnknowErrorException } from '@/domain/common/exceptions';

export const listReasonsExecute = async (listReasonsService) => {
  const {
    data: listReasons,
    responseCode,
    status,
    message,
  } = await listReasonsService();

  if (status === 200 && responseCode === '00') {
    return { responseCode, listReasons };
  } else {
    throw new UnknowErrorException({
      errorCode: responseCode,
      message,
    });
  }
};
